import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import App from './app';
import { AuthProvider } from './app/components/Auth';
import { ContextMenuProvider } from './app/components/ContextMenu';
import { FloatPanelProvider } from './app/components/FloatPanel';
import { LanguageProvider } from './app/components/Language';
import { LoadingProvider } from './app/components/LoadingScreen';
import { NavigatorProvider } from './app/components/Navigator';
import { NotifyProvider } from './app/components/Notify';
import { TitleBarTrackerProvider } from './app/components/TitleBarTracker';
import ContextureProvider from './components/Contexture/Contexture';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <LoadingProvider>
    <LanguageProvider>
      <NotifyProvider>
        <TitleBarTrackerProvider>
          <AuthProvider>
            <NavigatorProvider>
              <ContextureProvider>
                <ContextMenuProvider>
                  <FloatPanelProvider>
                    <App />
                  </FloatPanelProvider>
                </ContextMenuProvider>
              </ContextureProvider>
            </NavigatorProvider>
          </AuthProvider>
        </TitleBarTrackerProvider>
      </NotifyProvider>
    </LanguageProvider>
  </LoadingProvider>
);

serviceWorkerRegistration.unregister();

reportWebVitals();

